<template>
  <div v-if="!loading" class="page page-home" id="home">
    <div class="main-hero__wrapper">
      <SfHero
        class="main-hero"
        v-if="!bannersLoading"
        :style="{
          '--hero-item-background-size': 'cover',
          '--hero-item-background-position': 'center bottom',
          '--hero-item-wrapper-height': '100vh'
        }"
        :sliderOptions="{
          type: 'carousel',
          rewind: true
        }"
      >
        <a
          v-for="(hero, i) in heroes"
          :href="hero.link"
          :key="i"
          @click.native="bannerClicked(i+1)"
        >
          <SfHeroItem
            :background="hero.background"
            :image="hero.image"
            :link="hero.link"
          />
        </a>
      </SfHero>   
         
    </div>
    
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in platinumProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in platinumExtraProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in platinumExtraSecondProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <a target="_blank" href="https://t.me/vosiqmirzo">
      <SfBanner
        :link="banners[0].link"
        :image="banners[0].image"
        style="--banner-background-size: contain"
        @click.native="bannerClicked(3)"
      />
    </a>
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in goldProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in goldExtraProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <a target="_blank" href="https://t.me/cashu_uz" v-if="banners[1].image">
      <SfBanner
        :image="banners[1].image"
        style="--banner-background-size: contain"
        @click.native="bannerClicked(4)"
      />
    </a>  
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in silverProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in silverExtraProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in silverExtraSecondProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid"
      >
        <Product
          v-for="(product, i) in silverExtraThirdProducts"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <!-- <SfBanner
      :link="banners[2].link"
      :image="banners[2].image"
      style="--banner-background-size: contain; margin-top: 60px;"
    /> -->
    <SfHeading
      :level="1"
      title="Популярные"
      style="margin-top: 30px;"
    />
    <div class="products">
      <transition-group
        appear
        name="products__slide"
        tag="div"
        class="products__grid products__grid--all"
      >
        <Product
          v-for="(product, i) in productsAll"
          :key="product.slug"
          :product="product"
          :style="{ '--index': i }"
          :isOnWishlist="isOnWishlist"
          @toggleProductWishlist="toggleProductWishlist"
        />
      </transition-group>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 30px;">
      <SfButton @click="productsLimit += 10" v-if="productsLimit < products.length" class="classic-button">
        Больше
      </SfButton>
    </div>
    
  </div>
  <div v-else style="height: 100vh; width: 100%; display: flex; align-items: center; justify-content: center;">
    <SfLoader />
  </div>
</template>

<script>
import axios from 'axios'
import {
  SfHero, SfHeading, SfBanner, SfButton, SfLoader
} from '@storefront-ui/vue';

import Product from '../../components/Product'

import { createNamespacedHelpers } from 'vuex'
const { mapMutations, mapGetters } = createNamespacedHelpers('wishlist');

export default {
  name: "HomePage",
  components: {
    SfHero, SfHeading, SfBanner, SfButton, SfLoader,
    Product
  },
  data() {
    return {
      bannersLoading: true,
      loading: true,
      heroes: [
        {
          background: '#ffffff',
          image: {
            desktop: '/assets/homepage/hero1.jpg',
            mobile: '/assets/homepage/hero1_mobile.jpg',
          },
          link: 'shop/fonon'
        },
        {
          background: '#2a2a34',
          image: {
            desktop: '/assets/homepage/hero2.jpg',
            mobile: '/assets/homepage/hero2_mobile.jpg',
          },
          link: 'shop/fonon'
        },
      ],
      banners: [
        {
          background: '#ffffff',
          image: '/assets/homepage/bannerH.webp',
          link: 'catalog'
        },
        {
          background: '#2a2a34',
          image: '',
          link: 'catalog'
        },
        {
          background: '#2a2a34',
          image: '/assets/homepage/bannerA.webp',
          link: 'catalog'
        },
      ],
      products: [],
      productsLimit: 10,
      platinumProducts: [],
      platinumExtraProducts: [],
      platinumExtraSecondProducts: [],
      goldProducts: [],
      goldExtraProducts: [],
      silverProducts: [],
      silverExtraProducts: [],
      silverExtraSecondProducts: [],
      silverExtraThirdProducts: [],
    };
  },

  mounted() {
    this.getBanners();
    this.getProducts();
    this.getPlatinumProducts();
    this.getPlatinumExtraProducts();
    this.getPlatinumExtraSecondProducts();
    this.getGoldProducts();
    this.getGoldExtraProducts();
    this.getSilverProducts()
    this.getSilverExtraProducts()
    this.getSilverExtraSecondProducts()
    this.getSilverExtraThirdProducts().then(() => {
      this.loading = false;
      window.scrollTo(0, 0)
    });
  },

  computed: {
    ...mapGetters({
      isOnWishlist: 'isOnWishlist'
    }),
    productsAll() {
      return this.products.slice(0, this.productsLimit)
    }
  },
  
  methods: {
    ...mapMutations({
      toggleProductWishlist: 'ADD_PRODUCT'
    }),
    bannerClicked(id) {
      console.log(id)
      axios.post(`${process.env.VUE_APP_API_URL}/banner_analytics/${id}`)
          .then(() => {

          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`)
          .then((result) => {
            const { data } = result.data;
            this.products = data;
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getPlatinumProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'fonon',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.platinumProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getPlatinumExtraSecondProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'aureya',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.platinumExtraSecondProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getPlatinumExtraProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'vinceri',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.platinumExtraProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getGoldProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'uzgold-jewelry',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.goldProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getGoldExtraProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'silver-mania',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.goldExtraProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getSilverExtraProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'jewell',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.silverExtraProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getSilverExtraSecondProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'ramz-jewel',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.silverExtraSecondProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getSilverExtraThirdProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'silver-extra-third',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.silverExtraThirdProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getSilverProducts() {
      await axios.get(`${process.env.VUE_APP_API_URL}/products`, {
        params: {
          sortBy: 'desc',
          shop: 'almaz',
          is_on_main: true
        }
      })
          .then((result) => {
            const { data} = result.data;
            this.silverProducts = data.splice(0, 6);
          })
          .catch((error) => {
            console.log(error)
          });
    },
    async getBanners() {
      await axios.get(`${process.env.VUE_APP_API_URL}/settings/banners`)
          .then((result) => {
            const data = result.data;

            this.heroes[0].image = {
              desktop: process.env.VUE_APP_STORAGE + "/" + data[0].desktop_image,
              mobile: process.env.VUE_APP_STORAGE + "/" + data[0].mobile_image
            };

            this.heroes[1].image = {
              desktop: process.env.VUE_APP_STORAGE + "/" + data[1].desktop_image,
              mobile: process.env.VUE_APP_STORAGE + "/" + data[1].mobile_image
            };

            this.banners[0].image = {
              desktop: process.env.VUE_APP_STORAGE + "/" + data[2].desktop_image,
              mobile: process.env.VUE_APP_STORAGE + "/" + data[2].mobile_image
            };

            if(data[3].desktop_image && data[3].mobile_image) {
              this.banners[1].image = {
                desktop: process.env.VUE_APP_STORAGE + "/" + data[3].desktop_image,
                mobile: process.env.VUE_APP_STORAGE + "/" + data[3].mobile_image
              };
            }

            this.banners[2].image = {
              desktop: process.env.VUE_APP_STORAGE + "/" + data[4].desktop_image,
              mobile: process.env.VUE_APP_STORAGE + "/" + data[4].mobile_image
            };

            this.bannersLoading = false;
          })
          .catch((error) => {
            console.log(error)
          });
    },
    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },
  }
}
</script>

<style lang="scss" scoped>
#home {
  box-sizing: border-box;
  @include for-desktop {
    max-width: 1240px;
    margin: 0 auto;
  }
}
.section {
  padding: 0 var(--spacer-sm);
  @include for-desktop {
    padding: 0;
  }
}

.sf-hero-item {
  background-position: center;
  @media (min-width: 768px) {
    --hero-item-background-image: var( --_hero-item-background-desktop-image);
  }
}

.sf-banner {
  @media (min-width: 768px) {
    --banner-background-image: var( --_banner-background-desktop-image, var(--_banner-background-image) );
  }
}

.banner-grid {
  --banner-container-width: 50%;
  margin: var(--spacer-xl) 0;
  @include for-desktop {
    margin: var(--spacer-2xl) 0;
  }
}



.banner {
  &__tshirt {
    background-position: left;
  }
  &-central {
    @include for-desktop {
      --banner-container-flex: 0 0 70%;
    }
  }
}

.call-to-action {
  margin: var(--spacer-xl) 0;
  @include for-desktop {
    margin: var(--spacer-2xl) 0 0 0;
  }
}

.carousel {
    margin: 0 calc(var(--spacer-sm) * -1) 0 0;
  @include for-desktop {
    margin: 0;
  }
  &__item {
    margin: 1.9375rem 0 2.4375rem 0;
    &__product {
      --product-card-add-button-transform: translate3d(0, 30%, 0);
    }
  }
}

.images-grid {
  max-width: 60rem;
  margin: 0 auto;
  &__row {
    display: flex;
    & + & {
      margin: calc(var(--spacer-xl) / 2) 0 0 0;
      @include for-desktop {
        margin: var(--spacer-xl) 0 0 0;
      }
    }
  }
  &__col {
    flex: 1;
    margin: 0;
    & + & {
      margin: 0 0 0 calc(var(--spacer-xl) / 2);
      @include for-desktop {
        margin: 0 0 0 var(--spacer-xl);
      }
    }
  }
}

.products {
  box-sizing: border-box;
  flex: 1;
  margin: 0;
  &__grid,
  &__list {
    display: flex;
    flex-wrap: wrap;
  }
  &__product-card {

  }
  &__product-card-horizontal {
    flex: 0 0 100%;
  }
  &__slide-enter {
    opacity: 0;
    transform: scale(0.5);
  }
  &__slide-enter-active {
    transition: all 0.2s ease;
    transition-delay: calc(0.1s * var(--index));
  }
  @include for-desktop {
    &__grid {
      margin: var(--spacer-sm) 0 0 0;
    }
    &__pagination {
      display: flex;
      justify-content: flex-start;
      margin: var(--spacer-xl) 0 0 0;
    }
    &__product-card-horizontal {
      margin: var(--spacer-lg) 0;
    }
    &__product-card {
      flex: 1 1 20%;
    }
    &__list {
      margin: 0 0 0 var(--spacer-sm);
    }
  }
  &__show-on-page {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    &__label {
      font-family: var(--font-family--secondary);
      font-size: var(--font-size--sm);
    }
  }
}
</style>

<style lang="scss">
#home {
  .products__grid {
    .products__product-card:nth-child(6n) {
      @include for-desktop {
        display: none;
      }
    }
  }
  .products__grid--all {
    .products__product-card:nth-child(6n) {
      @include for-desktop {
        display: block;
      }
    }
  }
}
.sf-banner {
  @include for-desktop {
    min-height: unset;
    height: 0;
    padding-bottom: 17%;
    margin-top: 30px;
  }
}
.glide__slide a:hover {
  background: none;

}

.main-hero {
  position: absolute;
  left: 0;
  top: 100px;
  width: 100%;
}

.main-hero__wrapper {
  height: calc(100vh - 170px);
}

@media (min-width: 1024px) {
  .main-hero__wrapper {
    height: calc(100vh - 100px);
  }
}

.glide__slide.sf-hero-item {
  height: calc(100vh - 170px);
  background-position-y: bottom;
}

@media (min-width: 1024px) {
  .glide__slide.sf-hero-item {
    height: calc(100vh - 100px);
    background-position-y: center;
  }
}
</style>